import React, { Suspense, lazy, useCallback } from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import { ConnectedRouter } from "connected-react-router"
// import { I18nProvider } from "@lingui/react"

// Redux
import { connect } from "react-redux"

// UI Component
import { Header } from "./components/layouts"
import { Loader } from "./components/atoms"

// Public Container
import Login from "./screens/Login"
import Register from "./screens/Register"
import ForgotPassword from "./screens/ForgotPassword"
import ResetPassword from "./screens/ResetPassword"

// Admin Container
const Users = lazy(() => import("./screens/Users"))
const UserAddEdit = lazy(() => import("./screens/UserAddEdit"))
const Library = lazy(() => import("./screens/Library"))
const LibraryAddEdit = lazy(() => import("./screens/LibraryAddEdit"))
const Campaigns = lazy(() => import("./screens/Campaigns"))
const CampaignAddEdit = lazy(() => import("./screens/CampaignAddEdit"))
const Displays = lazy(() => import("./screens/Displays"))
const DisplayAddEdit = lazy(() => import("./screens/DisplayAddEdit"))
const DisplayEdit = lazy(() => import("./screens/DisplayEdit"))
const Content = lazy(() => import("./screens/Content"))
const Report = lazy(() => import("./screens/Report"))
const ReportDetail = lazy(() => import("./screens/ReportDetail"))
const Settings = lazy(() => import("./screens/Settings"))

// Advertiser
const RequestAssistance = lazy(() => import("./screens/RequestAssistance"))

const Template = lazy(() => import("./screens/Template"))

// Carrier Container
const Vehicles = lazy(() => import("./screens/Vehicles"))
const VehicleAddEdit = lazy(() => import("./screens/VehicleAddEdit"))

const AdminSwitch = () => {
  return (
    <div className="py-4 pb-10">
      <Switch>
        <Route exact path="/test" render={(props) => <Template {...props} />} />
        <Redirect from="/" to="/users" exact />
        <Route exact path="/users" render={(props) => <Users {...props} />} />
        <Route
          exact
          path="/useraddedit/:id?"
          render={(props) => <UserAddEdit {...props} />}
        />
        <Route
          exact
          path="/library"
          render={(props) => <Library {...props} />}
        />
        <Route
          exact
          path="/libraryaddedit/:id?"
          render={(props) => <LibraryAddEdit {...props} />}
        />
        <Route
          exact
          path="/campaigns"
          render={(props) => <Campaigns {...props} />}
        />
        <Route
          exact
          path="/campaignaddedit/:id?"
          render={(props) => <CampaignAddEdit {...props} />}
        />
        <Route
          exact
          path="/displays"
          render={(props) => <Displays {...props} />}
        />
        <Route
          exact
          path="/displayaddedit/:id?"
          render={(props) => <DisplayAddEdit {...props} />}
        />
        <Route
          exact
          path="/content"
          render={(props) => <Content {...props} />}
        />
        <Route exact path="/report" render={(props) => <Report {...props} />} />
        <Route
          exact
          path="/reportdetail/:id"
          render={(props) => <ReportDetail {...props} />}
        />
        <Route
          exact
          path="/requestassistance"
          render={(props) => <RequestAssistance {...props} />}
        />
        <Route
          exact
          path="/settings"
          render={(props) => <Settings {...props} />}
        />
      </Switch>
    </div>
  )
}

const AdvertiserSwitch = () => {
  return (
    <div className="py-8">
      <Switch>
        <Redirect from="/" to="/library" exact />
        <Route
          exact
          path="/library"
          render={(props) => <Library {...props} />}
        />
        <Route
          exact
          path="/libraryaddedit/:id?"
          render={(props) => <LibraryAddEdit {...props} />}
        />
        <Route
          exact
          path="/campaigns"
          render={(props) => <Campaigns {...props} />}
        />
        <Route
          exact
          path="/campaignaddedit"
          render={(props) => <CampaignAddEdit {...props} />}
        />
        <Route exact path="/report" render={(props) => <Report {...props} />} />
        <Route
          exact
          path="/reportdetail/:id"
          render={(props) => <ReportDetail {...props} />}
        />
        <Route
          exact
          path="/requestassistance"
          render={(props) => <RequestAssistance {...props} />}
        />
      </Switch>
    </div>
  )
}

const CarrierSwitch = () => {
  return (
    <div className="py-8">
      <Switch>
        <Redirect from="/" to="/displays" exact />
        <Route
          exact
          path="/displays"
          render={(props) => <Displays {...props} />}
        />
        <Route
          exact
          path="/displayedit/:id?"
          render={(props) => <DisplayEdit {...props} />}
        />
        <Route
          exact
          path="/vehicles"
          render={(props) => <Vehicles {...props} />}
        />
        <Route
          exact
          path="/vehicleaddedit/:id?"
          render={(props) => <VehicleAddEdit {...props} />}
        />
      </Switch>
    </div>
  )
}

const MultiRoleSwitch = () => {
  return (
    <div className="py-8">
      <Switch>
        <Redirect from="/" to="/library" exact />
        <Route
          exact
          path="/library"
          render={(props) => <Library {...props} />}
        />
        <Route
          exact
          path="/libraryaddedit/:id?"
          render={(props) => <LibraryAddEdit {...props} />}
        />
        <Route
          exact
          path="/campaigns"
          render={(props) => <Campaigns {...props} />}
        />
        <Route
          exact
          path="/campaignaddedit"
          render={(props) => <CampaignAddEdit {...props} />}
        />
        <Route
          exact
          path="/displays"
          render={(props) => <Displays {...props} />}
        />
        <Route
          exact
          path="/displayaddedit/:id?"
          render={(props) => <DisplayAddEdit {...props} />}
        />
        <Route
          exact
          path="/vehicles"
          render={(props) => <Vehicles {...props} />}
        />
        <Route
          exact
          path="/vehicleaddedit/:id?"
          render={(props) => <VehicleAddEdit {...props} />}
        />
        <Route
          exact
          path="/requestassistance"
          render={(props) => <RequestAssistance {...props} />}
        />
      </Switch>
    </div>
  )
}

const PublicSwitch = () => {
  return (
    <Switch>
      <Route exact path="/" render={(props) => <Login {...props} />} />
      <Route
        exact
        path="/forgotpassword"
        render={(props) => <ForgotPassword {...props} />}
      />
      <Route
        exact
        path="/resetpassword"
        render={(props) => <ResetPassword {...props} />}
      />
      <Route
        exact
        path="/register"
        render={(props) => <Register {...props} />}
      />
    </Switch>
  )
}

const AppRouter = (props) => {
  const roleSwitch = useCallback((role) => {
    switch (role) {
      case "admin":
        return <AdminSwitch />
      case "advertiser":
        return <AdvertiserSwitch />
      case "carrier":
        return <CarrierSwitch />
      case "advertiser,carrier":
        return <MultiRoleSwitch />
      default:
        return <PublicSwitch />
    }
  }, [])

  const { history, loader, token, role } = props

  const exceptionPaths = ["/register", "/forgotpassword", "/resetpassword"]

  let location = window.location

  if (token === null && exceptionPaths.indexOf(location.pathname) < 0) {
    props.history.push("/")
  }

  return (
    <Suspense fallback={<Loader />}>
      <ConnectedRouter history={history}>
        {loader && <Loader />}
        <Header {...props} />
        {roleSwitch(role)}
      </ConnectedRouter>
    </Suspense>
  )
}

const mapStateToProps = (state) => {
  return {
    loader: state.App.loader,
    token: state.Auth.access_token,
    role: state.Auth.role,
  }
}

export default connect(mapStateToProps, null)(AppRouter)
